import _ from 'lodash';

function getResource(context, name, endpoint, readResponse) {
    return new Promise((resolve, reject) => {
        if (!context.getters.isLoading(name)) {
            context.commit('setLoading', name);
            axios.get(endpoint)
                .then((response) => {
                    if (readResponse) {
                        readResponse(response);
                    } else {
                        context.commit('set', {
                            name,
                            list: response.data.data,
                        });
                    }
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                }).finally(() => {
                context.commit('unsetLoading', name);
            });
        } else {
            resolve();
        }
    });
}


export const composer = {
    state: {
        booted: [],
        loading: [],
        collapseMenus: [],
        galleries: [],
        showcases: [],
        videos: [],
        environments: [],
        forms: [],
        articleTypes: [],
        articleCategories: [],
        tags: [],
        translations: {}
    },
    getters: {
        isBooted: (state) => (method) => {
            return _.get(state.booted, method, false);
        },
        isLoading: (state) => (method) => {
            return _.get(state.loading, method, false);
        }
    },
    mutations: {
        setBooted (state, method) {
            Vue.set(state.booted, method, true);
        },
        setLoading (state, method) {
            Vue.set(state.loading, method, true);
        },
        unsetLoading (state, method) {
            Vue.set(state.loading, method, false);
        },
        set(state, {name, list}) {
            state[name] = list;
        },
        setTranslations (state, translations) {
            state.translations = translations;
        }
    },
    actions: {
        boot({ state, dispatch, commit }, method) {
            return new Promise((resolve, reject) => {
                if (!_.get(state.booted, method, false)) {
                    commit('setBooted', method);
                    return dispatch(method).then(() => {
                        resolve();
                    });
                } else {
                    resolve();
                }
            });
        },
        getCollapseMenus(context) {
            return getResource(
                context,
                'collapseMenus',
                '/api/backend/composer/resources/collapse-menus'
            );
        },
        getGalleries(context) {
            return getResource(
                context,
                'galleries',
                '/api/backend/composer/resources/galleries'
            );
        },
        getShowcases(context) {
            return getResource(
                context,
                'showcases',
                '/api/backend/composer/resources/showcases'
            );
        },
        getEnvironments(context) {
            return getResource(
                context,
                'environments',
                '/api/backend/composer/resources/environments'
            );
        },
        getVideos(context) {
            return getResource(
                context,
                'videos',
                '/api/backend/composer/resources/videos'
            );
        },
        getForms(context) {
            return getResource(
                context,
                'forms',
                '/api/backend/composer/resources/forms'
            );
        },
        getArticleTypes(context) {
            return getResource(
                context,
                'articleTypes',
                '/api/backend/composer/resources/article-types/'
            )
        },
        getArticleCategories(context) {
            return getResource(
                context,
                'articleCategories',
                '/api/backend/composer/resources/article-categories/'
            )
        },
        getTags(context) {
            return getResource(
                context,
                'tags',
                '/api/backend/composer/resources/article-tags'
            )
        }
    }
};
